
import { defineComponent } from "vue";

export default defineComponent({
  name: "incoming-summary",
  emit: ["reset"],
  components: {},
  props: {
    incoming: { type: Object, required: true },
    merchant: Object,
    processor: Object,
    reason: Object,
  },
  setup() {
    return {};
  },
});
